<template>
	<div class="uipwe12">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "j-box-horizontal-scroll"
}
</script>

<style src="./index.css" scoped />
